import ExportedImage from '@/components/shared/ExportedImage';
import Link from 'next/link';

import { motion } from 'framer-motion';

export const GuiApplications = ({ params }) => {
  return (
    <Link
      href={params.href}
      target='_blank'
      className={`${params.position === 'left' ? 'w-[220px] xs:w-[250px] sm:w-[239px] lg:w-[260px]' : 'w-[220px] xs:w-[250px] sm:w-[239px] md:ml-[22px] lg:ml-[10px] lg:w-[260px]'} ${params.class}`}
    >
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: 'spring' }}
      >
        <button className='contribute-btn flex w-full items-center justify-around p-2 sm:gap-[3px] sm:p-3 xl:gap-[8px] xl:px-[20px] xl:py-[13px] -md:px-[20px] -md:py-[13px]'>
          <span className='font-sans text-sm font-medium leading-[120%] text-white sm:text-base'>
            {params.heading}
          </span>
          <ExportedImage src={params.img} className='' alt={params.alt} />
        </button>
      </motion.div>
    </Link>
  );
};
